import * as e from "react";
const i = (s) => {
  const [a, c] = e.useState(!1), [n, o] = e.useState(0);
  return e.useEffect(() => {
    c(!!n);
  }, [n]), [async (...r) => {
    o((t) => t + 1);
    try {
      return await s(...r);
    } finally {
      o((t) => t - 1);
    }
  }, a];
};
export {
  i as useAsyncLoadingFn
};
//# sourceMappingURL=index.js.map
